<template>
  <v-card  outlined>
    <div class="pl-3 pt-3 font-weight-medium">Quantity Sold</div>
    <v-layout row wrap>
      <v-flex>
        <v-container grid-list-lg fluid>
          <v-layout row>
            <v-flex shrink>
              <v-avatar size="40" color="blue lighten-5">
                <v-icon small color="blue darken-4">mdi-cellphone</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex class="pb-0 ">
                  <div class="title">{{ serialized.quantity }}</div>
                  <!-- <div class="caption red--text">-{{ serialized.cost | currency }}</div>
                  <div class="caption green--text font-weight-bold">{{ serialized.profit | currency }}</div> -->
                </v-flex>
                <v-flex class="pt-0 caption">
                  Serialized
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex>
        <v-container grid-list-lg fluid>
          <v-layout row>
            <v-flex shrink>
              <v-avatar size="40" color="blue lighten-5">
                <v-icon small color="blue darken-4">mdi-headphones</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex class="pb-0 title font-weight-bold">
                  <div class="title">{{ itemized.quantity }}</div>
                  <!-- <div class="caption red--text">-{{ itemized.cost | currency }}</div>
                  <div class="caption green--text font-weight-bold">{{ itemized.profit | currency }}</div> -->
                </v-flex>
                <v-flex class="pt-0 caption">
                  Itemized
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex>
        <v-container grid-list-lg fluid>
          <v-layout row>
            <v-flex shrink>
              <v-avatar size="40" color="blue lighten-5">
                <v-icon small color="blue darken-4">mdi-cash-100</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex class="pb-0 title font-weight-bold">
                  <div class="title">{{ payments.quantity }}</div>
                  <!-- <div class="caption red--text">-{{ payments.cost | currency }}</div>
                  <div class="caption green--text font-weight-bold">{{ payments.profit | currency }}</div> -->

                </v-flex>
                <v-flex class="pt-0 caption">
                  Payments
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex>
        <v-container grid-list-lg fluid>
          <v-layout row>
            <v-flex shrink>
              <v-avatar size="40" color="cyan lighten-5">
                <v-icon small color="cyan darken-4">mdi-cellphone</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex class="pb-0 title font-weight-bold">
                  <div class="title">{{ services.quantity }}</div>
                  <!-- <div class="caption red--text">-{{ services.cost | currency }}</div>
                  <div class="caption green--text font-weight-bold">{{ services.profit | currency }}</div> -->

                </v-flex>
                <v-flex class="pt-0 caption">
                  Services
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex>
        <v-container grid-list-lg fluid>
          <v-layout row>
            <v-flex shrink>
              <v-avatar size="40" color="lime lighten-5">
                <v-icon small color="lime darken-4">mdi-cellphone</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex class="pb-0 title font-weight-bold">
                  <div class="title">{{ repairDevices.quantity }}</div>
                  <!-- <div class="caption red--text">-{{ repairDevices.cost | currency }}</div>
                  <div class="caption green--text font-weight-bold">{{ repairDevices.profit | currency }}</div> -->

                </v-flex>
                <v-flex class="pt-0 caption">
                  Repair Devices
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex>
        <v-container grid-list-lg fluid>
          <v-layout row>
            <v-flex shrink>
              <v-avatar size="40" color="green lighten-5">
                <v-icon small color="green darken-4">mdi-toolbox-outline</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex class="pb-0 title font-weight-bold">
                  <div class="title">{{ repairParts.quantity }}</div>
                  <!-- <div class="caption red--text">-{{ repairParts.cost | currency }}</div>
                  <div class="caption green--text font-weight-bold">{{ repairParts.profit | currency }}</div> -->

                </v-flex>
                <v-flex class="pt-0 caption">
                  Repair Parts
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-card>

</template>

<script>
export default {
  name: 'location-category',
  props: ['saleData'],
  data() {
    return {
      itemized: 0,
      serialized: 0,
      repairParts: 0,
      repairDevices: 0,
      payments: 0,
      services: 0,
    }
  },
  watch: {
    saleData() {
      this.loadData()
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {

      if (this.saleData.Itemized) {
        this.itemized = {
          quantity: parseInt(this.saleData.Itemized[0].Quantity) || 0,
          sale: this.saleData.Itemized[0].SaleAmount || 0,
          discount: this.saleData.Itemized[0].DetailDiscount || 0,
          cost: this.saleData.Itemized[0].CostAmount || 0,
          profit: parseFloat(this.saleData.Itemized[0].SaleAmount) - parseFloat(this.saleData.Itemized[0].DetailDiscount) - parseFloat(this.saleData.Itemized[0].CostAmount),
        }
      } else {
        this.itemized = {
          quantity: 0,
          sale: 0,
          discount: 0,
          cost: 0,
          profit: 0,
        }
      }

      if (this.saleData.Serialized) {
        this.serialized = {
          quantity: parseInt(this.saleData.Serialized[0].Quantity) || 0,
          sale: this.saleData.Serialized[0].SaleAmount || 0,
          discount: this.saleData.Serialized[0].DetailDiscount || 0,
          cost: this.saleData.Serialized[0].CostAmount || 0,
          profit: parseFloat(this.saleData.Serialized[0].SaleAmount) - parseFloat(this.saleData.Serialized[0].DetailDiscount) - parseFloat(this.saleData.Serialized[0].CostAmount),
        }
      } else {
        this.serialized = {
          quantity: 0,
          sale: 0,
          discount: 0,
          cost: 0,
          profit: 0,
        }
      }


      if (this.saleData.RepairParts) {
        this.repairParts = {
          quantity: parseInt(this.saleData.RepairParts[0].Quantity) || 0,
          sale: this.saleData.RepairParts[0].SaleAmount || 0,
          discount: this.saleData.RepairParts[0].DetailDiscount || 0,
          cost: this.saleData.RepairParts[0].CostAmount || 0,
          profit: parseFloat(this.saleData.RepairParts[0].SaleAmount) - parseFloat(this.saleData.RepairParts[0].DetailDiscount) - parseFloat(this.saleData.RepairParts[0].CostAmount),
        }
      } else {
        this.repairParts = {
          quantity: 0,
          sale: 0,
          discount: 0,
          cost: 0,
          profit: 0,
        }
      }

      if (this.saleData.RepairDevices) {
        this.repairDevices = {
          quantity: parseInt(this.saleData.RepairDevices[0].Quantity) || 0,
          sale: this.saleData.RepairDevices[0].SaleAmount || 0,
          discount: this.saleData.RepairDevices[0].DetailDiscount || 0,
          cost: this.saleData.RepairDevices[0].CostAmount || 0,
          profit: parseFloat(this.saleData.RepairDevices[0].SaleAmount) - parseFloat(this.saleData.RepairDevices[0].DetailDiscount) - parseFloat(this.saleData.RepairDevices[0].CostAmount),
        }
      } else {
        this.repairDevices = {
          quantity: 0,
          sale: 0,
          discount: 0,
          cost: 0,
          profit: 0,
        }
      }

      if (this.saleData.Payments) {
        this.payments = {
          quantity: parseInt(this.saleData.Payments[0].Quantity) || 0,
          sale: this.saleData.Payments[0].SaleAmount || 0,
          discount: this.saleData.Payments[0].DetailDiscount || 0,
          cost: this.saleData.Payments[0].CostAmount || 0,
          profit: parseFloat(this.saleData.Payments[0].SaleAmount) - parseFloat(this.saleData.Payments[0].DetailDiscount) - parseFloat(this.saleData.Payments[0].CostAmount),
        }
      } else {
        this.payments = {
          quantity: 0,
          sale: 0,
          discount: 0,
          cost: 0,
          profit: 0,
        }
      }

      if (this.saleData.Services) {
        this.services = {
          quantity: parseInt(this.saleData.Services[0].Quantity) || 0,
          sale: this.saleData.Services[0].SaleAmount || 0,
          discount: this.saleData.Services[0].DetailDiscount || 0,
          cost: this.saleData.Services[0].CostAmount || 0,
          profit: parseFloat(this.saleData.Services[0].SaleAmount) - parseFloat(this.saleData.Services[0].DetailDiscount) - parseFloat(this.saleData.Services[0].CostAmount),
        }
      } else {
        this.services = {
          quantity: 0,
          sale: 0,
          discount: 0,
          cost: 0,
          profit: 0,
        }
      }
    }
  }
}
</script>

<style scoped>
</style>